/**
 * Account type — must mirror the backend `AccountType` enum
 * (`apps/backend/src/libs/auth/roles-permissions.ts`).
 *
 * INTERNAL = staff (any internal user, no separate "admin"/"employee" tier).
 * EXTERNAL = customer.
 *
 * Admin status is derived from the assigned `Administrator` system role —
 * surfaced as `isAdmin` on the `/v1/auth/me` response.
 */
export const ACCOUNT_TYPE = {
  INTERNAL: 'INTERNAL',
  EXTERNAL: 'EXTERNAL',
} as const;

export type AccountType = (typeof ACCOUNT_TYPE)[keyof typeof ACCOUNT_TYPE];
